const isTouch = (): boolean => window.matchMedia('(pointer: coarse)').matches

export { isTouch }
